var BetterVits = {
  productIds: {
    6873017548976: "Glucosamine Complex",
    6873010405552: "Magnesium Complex",
    6873015255216: "Multivitamin",
    6873016598704: "Niacinamide",
    6873014501552: "Probiotic Complex",
    6938280558768: "Vitamin D3 & K2",
    6983776993456: "Turmeric Complex",
    6983778926768: "Marine Collagen Complex",
    7115537744048: "Menopause Complex",
    7119209234608: "PMS Complex",
    7119209955504: "Vitamin C",
    7231608455344: "Apple Cider Vinegar",
    7250764693680: "Ashwagandha",
    7250765381808: "Berberine",
    7250765021360: "Biotin Complex",
    7250764267696: "Kids Multivitamin",
    7250764497072: "Kids Probiotic",
    7250764824752: "Omega 3",
    7328448118960: "Coenzyme Q10",
    7328448544944: "Evening Primrose Oil",
    7328448446640: "Zinc",
    7328449069232: "Sound Asleep",
    7394296529072: "Creatine",
    7472617029808: "Mushroom Powder",
    7512646353072: "Protein Bar (Salted Caramel)",
    7512648089776: "Protein Bar (Chocolate Brownie)",
    7524339876016: "Pregnancy Support",
    7541881995440: "Hair, Skin & Nails",
    7541886091440: "Kids Multivitamin Gummies",
    7541885534384: "Manuka Honey",
    7541884813488: "Multivitamin Gummies",
    7613698736304: "Iron Complex",
    7613696737456: "Intimate Probiotic",
    7613697917104: "Vitamin B Complex",
    14907514126718: "NMN Complex",
    14903726113150: "PCOS Complex",
    14912537985406: "BetterGreens",
    15760281371006: "Metabolic+",
  },
  getProductVariant: {
    6873017548976: 40607291998384,
    6873010405552: 40607271551152,
    6873015255216: 40607286755504,
    6873016598704: 40607289475248,
    6873014501552: 40607285477552,
    6938280558768: 40827654406320,
    6983776993456: 41028621238448,
    6983778926768: 41028628218032,
    7115537744048: 41732127948976,
    7119209234608: 41746379899056,
    7119209955504: 41746382192816,
    7231608455344: 42145153777840,
    7250764693680: 42229897691312,
    7250765381808: 42229899788464,
    7250765021360: 42229898870960,
    7250764267696: 42229896446128,
    7250764497072: 42229897167024,
    7250764824752: 42229898150064,
    7328448118960: 42638975893680,
    7328448544944: 42638978023600,
    7328448446640: 42638977564848,
    7328449069232: 42638978711728,
    7394296529072: 42887457145008,
    7472617029808: 43178894262448,
    7512646353072: 43292730851504,
    7512648089776: 43292732227760,
    7524339876016: 43323189493936,
    7541881995440: 43374254096560,
    7541886091440: 43374296629424,
    7541885534384: 43374290403504,
    7541884813488: 43374282571952,
    7613698736304: 43584965476528,
    7613696737456: 43584949158064,
    7613697917104: 43584959217840,
    14907514126718: 54963591086462,
    14903726113150: 54952534540670,
    14912558104958: 54979369009534,
    15760281371006: 56858466320766
  },
  productImage: {
    "Glucosamine Complex": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-glucosamine-shadeless_x200.png?v=1698070629",
    "Magnesium Complex": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-magnesium-shadeless_x200.png?v=1698070724",
    Multivitamin: "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-multivitamin-shadeless_x200.png?v=1698070788",
    Niacinamide: "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-niacinamide-shadeless_x200.png?v=1698070819",
    "Probiotic Complex": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-probiotic-shadeless_x200.png?v=1698070906",
    "Vitamin D3 & K2": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-vitamin-d3-shadeless_x200.png?v=1698071061",
    "Turmeric Complex": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-turmeric-shadeless_x200.png?v=1698070994",
    "Marine Collagen Complex": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-collagen-shadeless_22502f85-7974-473c-870c-f90ead2cb696.png?v=1698070582",
    "Menopause Complex": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-menopause-shadeless_x200.png?v=1698070762",
    "PMS Complex": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-pms-shadeless_x200.png?v=1698070881",
    "Vitamin C": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-vitamin-c-shadeless_x200.png?v=1698071036",
    "Apple Cider Vinegar": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-acv-gummies-shadeless_x200.png?v=1698070407",
    Ashwagandha: "https://bettervits.co.uk/cdn/shop/files/ash-shadeless-new_1208d2f5-a257-4cfd-8315-a98757bc65a4_480x480.png?v=1710929084",
    Berberine: "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-berberine-shadeless_x200.png?v=1698070501",
    "Biotin Complex": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-biotin-shadeless_x200.png?v=1698070536",
    "Kids Multivitamin": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-kids-multivitamin-shadeless_x200.png?v=1698070661",
    "Kids Probiotic": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-kids-probiotic-shadeless_x200.png?v=1698070685",
    "Omega 3": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-omega-3-shadeless_x200.png?v=1698070857",
    "Coenzyme Q10": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-coq10-shadeless_x200.png?v=1698070560",
    "Evening Primrose Oil": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-primrose-oil-shadeless_x200.png?v=1698070611",
    Zinc: "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-zinc-shadeless_x200.png?v=1698071084",
    "Sound Asleep": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/new-sleep-shadeless_x200.png?v=1698070938",
    Creatine: "https://bettervits.co.uk/cdn/shop/files/creatine-cover_400x620.png?v=1697742212",
    "Mushroom Powder": "https://bettervits.co.uk/cdn/shop/files/first-mushroom_400x620.png?v=1709204798",
    "Protein Bar (Salted Caramel)": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/bar-box_x200.png?v=1711460241",
    "Protein Bar (Chocolate Brownie)": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/bar-box-choc_x200.png?v=1711460241",
    "Pregnancy Support": "https://bettervits.co.uk/cdn/shop/files/pregnancy-cover_07710337-d2d2-40c1-ad91-9669e2f4f537_600x820.png?v=1712228481",
    "Hair, Skin & Nails": "https://bettervits.co.uk/cdn/shop/files/hair-cover_400x620.png?v=1712651545",
    "Kids Multivitamin Gummies": "https://bettervits.co.uk/cdn/shop/files/kmg-cover_400x620.png?v=1712652038",
    "Manuka Honey": "https://bettervits.co.uk/cdn/shop/files/manuka-cover_400x620.png?v=1712651984",
    "Multivitamin Gummies": "https://bettervits.co.uk/cdn/shop/files/mg-cover_400x620.png?v=1712651884",
    "Iron Complex": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/iron-shaded.png?v=1715780956",
    "Intimate Probiotic": "https://cdn.shopify.com/s/files/1/0533/0970/2320/files/ip-shaded1.png?v=1715696808",
    "Vitamin B Complex": "https://bettervits.co.uk/cdn/shop/files/bcomp-shaded_f1e22002-3d53-4494-9ca6-5f4af01a9e59_400x620.png?v=1715684554",
    "NMN Complex": "https://bettervits.co.uk/cdn/shop/files/nmn-cover_400x620.png?v=1738067813",
    "PCOS Complex": "https://bettervits.co.uk/cdn/shop/files/pcos-cover_400x620.png?v=1738146180",
    BetterGreens: "https://bettervits.co.uk/cdn/shop/files/greens-cover_400x620.png?v=1738327527",
    "Metabolic+": "https://bettervits.co.uk/cdn/shop/files/metabolic-PDP-gallery-slide-1_400x620.jpg?v=1769509971"
  },
  getDiscountedProductsName: {
    6875451883696: "Glucosamine Complex",
    6875451588784: "Magnesium Complex",
    6875450998960: "Multivitamin",
    6875450572976: "Niacinamide",
    6875449393328: "Probiotic Complex",
    6938280788144: "Vitamin D3 & K2",
    6983807140016: "Turmeric Complex",
    6983807008944: "Marine Collagen Complex",
    7119123284144: "Menopause Complex",
    7119209496752: "PMS Complex",
    7119210414256: "Vitamin C",
    7250763710640: "Apple Cider Vinegar",
    7250764759216: "Ashwagandha",
    7250765512880: "Berberine",
    7250765185200: "Biotin Complex",
    7250764333232: "Kids Multivitamin",
    7250764529840: "Kids Probiotic",
    7250764890288: "Omega 3",
    7328448250032: "Coenzyme Q10",
    7328449003696: "Evening Primrose Oil",
    7328448479408: "Zinc",
    7328449167536: "Sound Asleep",
    7394298626224: "Creatine",
    7472617914544: "Mushroom Powder",
    7512648024240: "Protein Bar (Salted Caramel)",
    7512648122544: "Protein Bar (Chocolate Brownie)",
    7524340170928: "Pregnancy Support",
    7541882159280: "Hair, Skin & Nails",
    7541886255280: "Kids Multivitamin Gummies",
    7541885730992: "Manuka Honey",
    7541885173936: "Multivitamin Gummies",
    7613698834608: "Iron Complex",
    7613697196208: "Intimate Probiotic",
    7613698277552: "Vitamin B Complex",
    14907515076990: "NMN Complex",
    14909956391294: "PCOS Complex",
    14912558104958: "BetterGreens",
    15760281895294: "Metabolic+"
  },
  getDiscountedProductID: {
    // regular product ID : discounted product ID
    6873017548976: 6875451883696,
    6873010405552: 6875451588784,
    6873015255216: 6875450998960,
    6873016598704: 6875450572976,
    6873014501552: 6875449393328,
    6938280558768: 6938280788144,
    6983776993456: 6983807140016,
    6983778926768: 6983807008944,
    7115537744048: 7119123284144,
    7119209234608: 7119209496752,
    7119209955504: 7119210414256,
    7231608455344: 7250763710640,
    7250764693680: 7250764759216,
    7250765381808: 7250765512880,
    7250765021360: 7250765185200,
    7250764267696: 7250764333232,
    7250764497072: 7250764529840,
    7250764824752: 7250764890288,
    7328448118960: 7328448250032,
    7328448544944: 7328449003696,
    7328448446640: 7328448479408,
    7328449069232: 7328449167536,
    7394296529072: 7394298626224,
    7472617029808: 7472617914544,
    7512646353072: 7512648024240,
    7512648089776: 7512648122544,
    7524339876016: 7524340170928,
    7541881995440: 7541882159280,
    7541886091440: 7541886255280,
    7541885534384: 7541885730992,
    7541884813488: 7541885173936,
    7613698736304: 7613698834608,
    7613696737456: 7613697196208,
    7613697917104: 7613698277552,
    14907514126718: 14907515076990,
    14903726113150: 14909956391294,
    14912537985406: 14912558104958,
    15760281371006: 15760281895294
  },
  getDiscountedProductVariant: {
    // discounted product ID: discounted product variant ID
    6875451883696: 40617579675824,
    6875451588784: 40617579118768,
    6875450998960: 40617577676976,
    6875450572976: 40617577087152,
    6875449393328: 40617573482672,
    6938280788144: 40827654865072,
    6983807140016: 41028815814832,
    6983807008944: 41028815585456,
    7119123284144: 41746064375984,
    7119209496752: 41746380521648,
    7119210414256: 41746383044784,
    7250763710640: 42229894381744,
    7250764759216: 42229897855152,
    7250765512880: 42229899985072,
    7250765185200: 42229899133104,
    7250764333232: 42229896609968,
    7250764529840: 42229897298096,
    7250764890288: 42229898281136,
    7328448250032: 42638976614576,
    7328449003696: 42638978646192,
    7328448479408: 42638977597616,
    7328449167536: 42638978810032,
    7394298626224: 42887472677040,
    7472617914544: 43178895278256,
    7512648024240: 43292732063920,
    7512648122544: 43292732260528,
    7524340170928: 43323191034032,
    7541882159280: 43374255833264,
    7541886255280: 43374298398896,
    7541885730992: 43374292172976,
    7541885173936: 43374286471344,
    7613698834608: 43584966295728,
    7613697196208: 43584953778352,
    7613698277552: 43584962363568,
    14907515076990: 54963592561022,
    14909956391294: 54970317406590,
    14912558104958: 54979369009534,
    15760281895294: 56858468745598
  },
  mapDiscounts: {
    // regular product ID : discounted product ID
    6873017548976: 6875450998960,
    6873010405552: 6875450998960,
    6873015255216: 6875449393328, // Multivitamin's upsell is Probiotic
    6873016598704: 6875450998960,
    6873014501552: 6875450998960,
    6938280558768: 6875450998960, // Vitamin D3 & K2's upsell is multivitamin
    6983776993456: 6875450998960,
    6983778926768: 6875450998960,
    6983778926768: 6875450998960,
    7115537744048: 6875449393328,
    7119209234608: 6875449393328,
    7119209955504: 6875449393328,
    7231608455344: 6875449393328, // ACV's upsell is Probiotic
    7250764693680: 6875449393328, // Ashwagandha's upsell is Probiotic
    7250765381808: 6875449393328, // BC's upsell is Probiotic
    7250765021360: 6875449393328, // Biotin - Probiotic
    7250764267696: 7250764529840, // Kids Multivitamin - Kids Probiotic
    7250764497072: 7250764333232, // Kids Probiotic - Kids Multivitamin
    7250764824752: 6875449393328, // Omega 3 - Probiotic
    7328448118960: 6875450998960, // C10 - Multivitamin
    7328448544944: 6875450998960, // Primrose - Multivitamin
    7328448446640: 6875451588784, // Zinc - Magnesium
    7328449069232: 7250763710640, // Sleep - ACV
    7394296529072: 7512648122544,
    7472617029808: 7472617914544,
    7512646353072: 7512648122544, // PB SC - PB CB
    7512648089776: 7512648024240, // PB CB - PB SC
    7524339876016: 7328449167536, // Pregnancy - Asleep
    7541881995440: 6983807008944, // HSN - Collagen
    7541886091440: 6875450998960, // KMG- Multivitamin
    7541885534384: 7541882159280, // Manuka - HSN
    7541884813488: 7328449167536, // MG - Asleep
    7613698736304: 6875450998960, // Iron - Multi
    7613696737456: 6875450998960, // Intimate - Multi
    7613697917104: 6875451588784, // B Complex - Magnesium
    14907514126718: 6875450998960, // NMN - Multivitamin
    14903726113150: 7613697196208, // PCOS - IP
    14912537985406: 7472617914544, // Greens - Mushroom
    15760281371006: 15760281895294 // Metabolic+ - Metabolic+
  },

  productsSelingPlans: {
    // Variant ID / Selling Plans
    40607291998384: [752877744, 789479600, 789512368], // Glucosamine
    40607285477552: [753008816, 789938352, 789971120], // Probiotic
    41028621238448: [756711600, 790069424, 790102192], // Turmeric
    41028628218032: [711250444670, 711250477438, 711250510206], // Collagen
    40607271551152: [752943280, 790593712, 790626480], // Magnesium
    40607289475248: [752910512, 789807280, 789840048], // Niacinamide
    40607286755504: [752976048, 789676208, 789708976], // Multivitamin
    40827654406320: [753041584, 790200496, 790233264], // Vitamin D3 & K2
    41732127948976: [923697328, 923762864, 923795632], // Menopause
    41746379899056: [923959472, 924156080, 924188848], // PMS Complex
    41746382192816: [923926704, 924025008, 924057776], // Vitamin C
    42145153777840: [1060995248, 1061322928, 1061355696], // ACV
    42229897691312: [1061093552, 1061454000, 1061486768], // Ashwagandha
    42229899788464: [1061224624, 1061585072, 1061617840], // BC
    42229898870960: [1060896944, 1061716144, 1061748912], // Biotin
    42229896446128: [1061159088, 1061847216, 1061879984], // Kids Multivitamin
    42229897167024: [1060929712, 1061978288, 1062011056], // Kids Probiotic
    42229898150064: [1061191856, 1062142128, 1062174896], // Omega 3
    42638975893680: [1122042032, 1122140336, 1122173104], // C10
    42638978023600: [1122107568, 1122271408, 1122304176], // Primrose
    42638977564848: [1122533552, 1122566320, 1122599088], // Zinc
    42638978711728: [1122730160, 1122762928, 1122795696], // Sleep
    42887457145008: [1583218864, 1583251632, 1583284400, 1583317168, 1583349936], // Creatine
    43178894262448: [1770094768, 1770127536, 1770160304], // Mushroom
    43292730851504: [1829568688, 1829601456, 1829634224], // PB SC
    43292732227760: [1829666992, 1829699760, 1829732528], // PB CB
    43323189493936: [1840185520, 1840218288, 1840251056], // Pregnancy
    43374254096560: [1844052144, 1844084912, 1844117680], // HSN
    43374296629424: [1844248752, 1844281520, 1844314288], // KMG
    43374290403504: [1844445360, 1844478128, 1844510896], // Manuka
    43374282571952: [1844641968, 1844674736, 1844707504], // MG
    43584965476528: [1872691376, 1872724144, 1872756912], // Iron
    43584949158064: [1872298160, 1872330928, 1872363696], // Intimate
    43584959217840: [1872494768, 1872527536, 1872560304], // Vit B
    54963591086462: [710309413246, 710309446014, 710309478782], // NMN
    54952534540670: [710310068606, 710310101374, 710310134142], // PCOS
    54979264938366: [710432817534, 710432883070, 710432915838], // Greens
    56858466320766: [711156924798, 711156957566, 711156990334,] // Metabolic+
  },
  offersSellingPlans: {
    41028815585456: [789151920, 789348528, 789381296], // Collagen
    40617579675824: [789184688, 789545136, 789577904], // Glucosamine
    40617579118768: [789217456, 789610672, 789643440], // Magnesium
    40617577676976: [789086384, 789741744, 789774512], // Multivitamin
    40617577087152: [789282992, 789872816, 789905584], // Niacinamide
    40617573482672: [789250224, 790003888, 790036656], // Probiotic
    41028815814832: [789315760, 790134960, 790167728], // Turmeric
    40827654865072: [789119152, 790266032, 790298800], // Vitamin D3 & K2
    41746064375984: [923730096, 923828400, 923861168], // Menopause
    41746380521648: [923893936, 924221616, 924254384], // PMS Complex
    41746383044784: [923992240, 924090544, 924123312], // Vitamin C
    42229894381744: [1061060784, 1061388464, 1061421232], // ACV
    42229897855152: [1061257392, 1061519536, 1061552304], // Ashwagandha
    42229899985072: [1061126320, 1061650608, 1061683376], // BC
    42229899133104: [1060962480, 1061781680, 1061814448], // Biotin
    42229896609968: [1061290160, 1061912752, 1061945520], // Kids Multivitamin
    42229897298096: [1062043824, 1062076592, 1062109360], // Kids Probiotic
    42229898281136: [1062207664, 1062240432, 1062273200], // Omega 3
    42638976614576: [1122074800, 1122205872, 1122238640], // C10
    42638978646192: [1122336944, 1122369712, 1122402480], // Primrose
    42638977597616: [1122435248, 1122468016, 1122500784], // Zinc
    42638978810032: [1122631856, 1122664624, 1122697392], // Sleep
    42887472677040: [1583382704, 1583415472, 1583448240, 1583481008, 1583513776], //Creatine
    43178895278256: [1770193072, 1770225840, 1770258608], //Mushroom
    43292732063920: [1829765296, 1829798064, 1829830832], // PB SC
    43292732260528: [1829863600, 1829896368, 1829929136], // PB CB
    43323191034032: [1840283824, 1840316592, 1840349360], // Pregnancy
    43374255833264: [1844150448, 1844183216, 1844215984], // HSM
    43374298398896: [1844347056, 1844379824, 1844412592], // KMG
    43374292172976: [1844543664, 1844576432, 1844609200], //Manuka
    43374286471344: [1844740272, 1844773040, 1844805808], // MG
    43584966295728: [1872789680, 1872822448, 1872855216], // Iron
    43584953778352: [1872396464, 1872429232, 1872462000], // Intimate
    43584962363568: [1872593072, 1872625840, 1872658608], // Vit B
    54963592561022: [710309511550, 710309544318, 710309577086], // NMN
    54970317406590: [710310166910, 710310199678, 710310232446], // PCOS
    54979369009534: [710432751998, 710432784766, 710432850302], // Greens
    56858468745598: [711157023102, 711157055870, 711157088638,] // Metabolic+
  },
  isSafari: !!navigator.userAgent.match(/Version\/[\d\.]+.*Safari/),
  iOS: /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream,
  cornerElement: document.querySelector(".green-section--tocorner"),
  initCarsousels: () => {
    if (document.getElementById("product-slider")) {
       var productName = document.querySelector("h1.product-atf__content-title").innerText.toLowerCase();
      if (productName.indexOf("bettergreens") == -1){
      Array.from(document.querySelectorAll("#product-slider .splide__slide"))
        .slice(2)
        .forEach((el) => el.remove());
      Array.from(document.querySelectorAll("#thumbnail-slider .splide__slide"))
        .slice(2)
        .forEach((el) => el.remove());
      }
      var main = new Splide("#product-slider", {
        perPage: 1,
        gap: "1rem",
        speed: 600,
        easing: "cubic-bezier(0.55, 0.24, 0.52, 0.6)",
        autoplay: false,
        center: false,
        interval: 6000,
        padding: "0",
        pagination: false,
        dots: false,
        arrows: false,
        arrowPath:
          "M1.60547 4.8813C1.21887 4.8813 0.905469 5.1947 0.905469 5.5813C0.905469 5.9679 1.21887 6.2813 1.60547 6.2813L1.60547 4.8813ZM25.3717 6.07627C25.6451 5.80291 25.6451 5.35969 25.3717 5.08633L20.9169 0.631552C20.6435 0.358185 20.2003 0.358185 19.927 0.631552C19.6536 0.904919 19.6536 1.34813 19.927 1.6215L23.8868 5.5813L19.927 9.5411C19.6536 9.81446 19.6536 10.2577 19.927 10.531C20.2003 10.8044 20.6435 10.8044 20.9169 10.531L25.3717 6.07627ZM1.60547 5.5813L1.60547 6.2813L13.2411 6.2813L13.2411 5.5813L13.2411 4.8813L1.60547 4.8813L1.60547 5.5813ZM13.2411 5.5813L13.2411 6.2813L24.8767 6.2813L24.8767 5.5813L24.8767 4.8813L13.2411 4.8813L13.2411 5.5813Z",
      });

      var thumbnails = new Splide("#thumbnail-slider", {
        fixedWidth: "calc(17.1% - 1rem)",
        gap: "1rem",
        pagination: false,
        isNavigation: true,
        center: false,
        arrows: false,
        breakpoints: {},
      });

      thumbnails.mount();
      main.sync(thumbnails);
      main.mount();
    }

      if (document.getElementById("vouched-for-slider")) {
            new Splide("#vouched-for-slider", {
                type: "slide",
                perPage: document.body.classList.contains("about") ? 5 : 3,
                gap: "1rem",
                speed: 333,
                easing: "cubic-bezier(0.55, 0.24, 0.52, 1.0)",
                autoplay: false,
                interval: 6000,
                padding: { right: "10%" },
                pagination: false,
                arrows: true,
                arrowPath:
                    "M1.60547 4.8813C1.21887 4.8813 0.905469 5.1947 0.905469 5.5813C0.905469 5.9679 1.21887 6.2813 1.60547 6.2813L1.60547 4.8813ZM25.3717 6.07627C25.6451 5.80291 25.6451 5.35969 25.3717 5.08633L20.9169 0.631552C20.6435 0.358185 20.2003 0.358185 19.927 0.631552C19.6536 0.904919 19.6536 1.34813 19.927 1.6215L23.8868 5.5813L19.927 9.5411C19.6536 9.81446 19.6536 10.2577 19.927 10.531C20.2003 10.8044 20.6435 10.8044 20.9169 10.531L25.3717 6.07627ZM1.60547 5.5813L1.60547 6.2813L13.2411 6.2813L13.2411 5.5813L13.2411 4.8813L1.60547 4.8813L1.60547 5.5813ZM13.2411 5.5813L13.2411 6.2813L24.8767 6.2813L24.8767 5.5813L24.8767 4.8813L13.2411 4.8813L13.2411 5.5813Z",
                breakpoints: {
                    767: {
                        perPage: 1,
                        padding: { right: "20%" },
                    },
                    1024: {
                        perPage: document.body.classList.contains("about") || document.body.classList.contains("reviews") ? 5 : 3,
                    },
                },
            }).mount();
        }

    if (document.getElementById("loved-by-slider")) {
      new Splide("#loved-by-slider", {
        type: "loop",
        perPage: 5,
        gap: "1rem",
        speed: 333,
        easing: "cubic-bezier(0.55, 0.24, 0.52, 1.0)",
        autoplay: false,
        interval: 6000,
        padding: "0",
        pagination: false,
        arrows: false,
        arrowPath:
          "M1.60547 4.8813C1.21887 4.8813 0.905469 5.1947 0.905469 5.5813C0.905469 5.9679 1.21887 6.2813 1.60547 6.2813L1.60547 4.8813ZM25.3717 6.07627C25.6451 5.80291 25.6451 5.35969 25.3717 5.08633L20.9169 0.631552C20.6435 0.358185 20.2003 0.358185 19.927 0.631552C19.6536 0.904919 19.6536 1.34813 19.927 1.6215L23.8868 5.5813L19.927 9.5411C19.6536 9.81446 19.6536 10.2577 19.927 10.531C20.2003 10.8044 20.6435 10.8044 20.9169 10.531L25.3717 6.07627ZM1.60547 5.5813L1.60547 6.2813L13.2411 6.2813L13.2411 5.5813L13.2411 4.8813L1.60547 4.8813L1.60547 5.5813ZM13.2411 5.5813L13.2411 6.2813L24.8767 6.2813L24.8767 5.5813L24.8767 4.8813L13.2411 4.8813L13.2411 5.5813Z",
        breakpoints: {
          767: {
            perPage: 1,
            padding: { right: "20%" },
            arrows: 1,
          },
          1024: {
            perPage: 3,
            gap: "1rem",
            padding: { right: "20%" },
            arrows: 1,
          },
        },
      }).mount();
    }
    if (document.getElementById("nutritionists-slider")) {
      new Splide("#nutritionists-slider", {
        type: "loop",
        perPage: 2,
        gap: "2rem",
        speed: 333,
        easing: "cubic-bezier(0.55, 0.24, 0.52, 1.0)",
        autoplay: false,
        interval: 6000,
        padding: { right: "5%" },
        pagination: false,
        arrows: true,
        arrowPath:
          "M1.60547 4.8813C1.21887 4.8813 0.905469 5.1947 0.905469 5.5813C0.905469 5.9679 1.21887 6.2813 1.60547 6.2813L1.60547 4.8813ZM25.3717 6.07627C25.6451 5.80291 25.6451 5.35969 25.3717 5.08633L20.9169 0.631552C20.6435 0.358185 20.2003 0.358185 19.927 0.631552C19.6536 0.904919 19.6536 1.34813 19.927 1.6215L23.8868 5.5813L19.927 9.5411C19.6536 9.81446 19.6536 10.2577 19.927 10.531C20.2003 10.8044 20.6435 10.8044 20.9169 10.531L25.3717 6.07627ZM1.60547 5.5813L1.60547 6.2813L13.2411 6.2813L13.2411 5.5813L13.2411 4.8813L1.60547 4.8813L1.60547 5.5813ZM13.2411 5.5813L13.2411 6.2813L24.8767 6.2813L24.8767 5.5813L24.8767 4.8813L13.2411 4.8813L13.2411 5.5813Z",
        breakpoints: {
          767: {
            perPage: 1,
            padding: { right: "15%" },
          },
          1024: {
            perPage: 3,
            gap: "1rem",
          },
        },
      }).mount();
    }

    if (document.getElementById("ingredients-slider")) {
      var productName = document.querySelector("h1.product-atf__content-title").innerText.toLowerCase();
      var slidesPerPage = 3,
        hasArrows = true;
      if (
        productName.indexOf("creatine") > -1 ||
        productName.indexOf("vitamin b") > -1 ||
        productName.indexOf("zinc") > -1 ||
        productName.indexOf("q10") > -1 ||
        productName.indexOf("primrose") > -1 ||
        productName.indexOf("vitamin c") > -1 ||
        productName.indexOf("biotin") > -1 ||
        productName.indexOf("d3") > -1
      ) {
        slidesPerPage = 2;
        hasArrows = false;
      }
      if (productName.indexOf("collagen") > -1) {
        slidesPerPage = 3;
      }
       if (productName.indexOf("q10") > -1||
        productName.indexOf("berberine") > -1) {
        slidesPerPage = 1;
         hasArrows = false;
      }

      if (document.querySelectorAll("#ingredients-slider .splide__slide").length <= 3 && window.innerWidth >= 1220) {
        hasArrows = false;
      }
      new Splide("#ingredients-slider", {
        type: "slide",
        gap: "1rem",
        speed: 700,
        perPage: slidesPerPage,
        easing: "cubic-bezier(0.55, 0.24, 0.52, 1.0)",
        autoplay: false,
        interval: 600000,
        padding: 0,
        updateOnMove: false,
        pagination: false,
        drag: hasArrows || window.innerWidth <= 767,
        arrows: hasArrows,
        dots: false,
        arrowPath:
          "M1.60547 4.8813C1.21887 4.8813 0.905469 5.1947 0.905469 5.5813C0.905469 5.9679 1.21887 6.2813 1.60547 6.2813L1.60547 4.8813ZM25.3717 6.07627C25.6451 5.80291 25.6451 5.35969 25.3717 5.08633L20.9169 0.631552C20.6435 0.358185 20.2003 0.358185 19.927 0.631552C19.6536 0.904919 19.6536 1.34813 19.927 1.6215L23.8868 5.5813L19.927 9.5411C19.6536 9.81446 19.6536 10.2577 19.927 10.531C20.2003 10.8044 20.6435 10.8044 20.9169 10.531L25.3717 6.07627ZM1.60547 5.5813L1.60547 6.2813L13.2411 6.2813L13.2411 5.5813L13.2411 4.8813L1.60547 4.8813L1.60547 5.5813ZM13.2411 5.5813L13.2411 6.2813L24.8767 6.2813L24.8767 5.5813L24.8767 4.8813L13.2411 4.8813L13.2411 5.5813Z",
        breakpoints: {
          767: {
            perPage: 1,
            padding: { right: "15%" },
          },
          1024: {
            perPage: 2,
            padding: { right: "15%" },
          },
        },
      }).mount();
    }
  },
  isElementInView: (el) => {
    var rect = el.getBoundingClientRect();
    var elemTop = rect.top;
    var elemBottom = rect.bottom;
    var isVisible = elemTop >= 0 && elemBottom <= window.innerHeight + 200;
    return isVisible;
  },
  customSticky: () => {
    if (window.scrollY >= 10) {
      document.querySelector("header.header").classList.add("header--sticky");
    } else {
      document.querySelector("header.header").classList.remove("header--sticky");
    }
  },
  initMobileMenu: () => {
    document.querySelector(".header__toggle").addEventListener("click", function (ev) {
      ev.preventDefault();
      document.querySelector(".header__nav").classList.toggle("active");
    });
  },
  initFAQ: () => {
    var questions = document.querySelectorAll(".faqs__list-question");
    for (var j = 0; j < questions.length; j++) {
      questions[j].addEventListener("click", function (ev) {
        ev.preventDefault();
        ev.stopImmediatePropagation();
        ev.stopPropagation();
        var that = this;
        if (that.classList.contains("active")) {
          that.nextElementSibling.classList.remove("active");
          that.classList.remove("active");
        } else {
          var answers = document.querySelectorAll(".faqs__list-answer");

          for (var i = 0; i < answers.length; i++) {
            answers[i].classList.remove("active");
          }

          for (var j = 0; j < questions.length; j++) {
            questions[j].classList.remove("active");
          }

          that.classList.add("active");
          that.nextElementSibling.classList.add("active");
        }
      });
    }
  },
  returnUpsellPrice: function (upsellID) {
    var upsellPrice = 19.99;
    if (upsellID == 6875450998960) {
      upsellPrice = 16.99;
    }
    if (upsellID == 14912558104958) {
      upsellPrice = 29.99;
    }
    if (upsellID == 14907515076990 || upsellID == 7512648024240 || upsellID == 7512648122544) {
      upsellPrice = 25;
    }
    return upsellPrice;
  },
  cartUpsellInit: (quantity, metaproduct, isCart) => {
    var productID = metaproduct.id;
    var variantID = metaproduct.variants[0].id;
    var isSub;
    var quantity = parseInt(quantity);
    var upsellID = isCart ? BetterVits.getDiscountedProductID[productID] : BetterVits.mapDiscounts[productID],
      upsellName = BetterVits.getDiscountedProductsName[upsellID],
      upsellImage = BetterVits.productImage[upsellName],
      upsellElement = document.querySelector(".upsell"),
      upsellTitle = "",
      upsellContent = "",
      upsellPrice = 19.99,
      upsellTitleElement = document.querySelector(".upsell b"),
      upsellContentElement = document.querySelector(".upsell p"),
      isSoloProduct = variantID == 43178894262448 || variantID == 43374296629424,
      upsellImageElement = document.querySelector(".upsellimg"),
      keyword = "Bottle",
      isBox = false,
      isMulti = false,
      isNMN = false,
      isGreens = false;

    if (upsellID == 7394298626224) {
      keyword = "Jar";
    }
    if (upsellID == 7472617914544 || upsellID == 14912558104958) {
      keyword = "Pouch";
    }
    if (upsellID == 7512648024240 || upsellID == 7512648122544) {
      keyword = "Box";
      isBox = true;
    }

    if (isCart) {
      upsellElement = document.querySelector(".cart-items__item--upsell");
      (upsellTitleElement = document.querySelector(".cart-items__item--upsell h4 span:not(.orange)")),
        (upsellContentElement = document.querySelector(".cart-items__item--upsell p")),
        (upsellImageElement = document.querySelector(".cart-items__item--upsell .cart-items__item-image img"));
    }
    upsellElement.classList.add("hidden");

    switch (upsellName) {
      case "Multivitamin":
        upsellTitle = "Add Multivitamin For £16.99";
        upsellContent = "Try this 13-in-1 Multivitamin To Boost Your Health For 35% OFF!";
        break;
      case "Kids Multivitamin":
        upsellTitle = "Add a Kids Multivitamin For £19.99?";
        upsellContent = "Use this balanced everyday multivitamin to boost your kids health & energy alongside your purchase!";
        break;
      case "Kids Probiotic":
        upsellTitle = "Add Our Kids Probiotic For Just £19.99?";
        upsellContent = "Get 50% off our Kids Probiotic and start improving your kids gut health today!";
        break;
      case "Magnesium Complex":
        upsellTitle = "Add Our Magnesium For £19.99?";
        upsellContent = "Try our powerfully enriching Magnesium supplement for 33% off today.";
        break;
      case "Probiotic Complex":
        upsellTitle = "Add Our Probiotic For Just £19.99?";
        upsellContent = "Get 50% off our Probiotic Complex and start improving your gut health today!";
        break;
      case "Vitamin D3 & K2":
        upsellTitle = "Add Our Vitamin D3 & K2 For Just £19.99?";
        upsellContent = "Get 50% off our Vitamin D3 & K2 and start improving your health today!";
        break;
      case "Apple Cider Vinegar":
        upsellTitle = "Add ACV Gummies For £19.99?";
        upsellContent = "Get 50% off these delicious Apple Cider Vinegar gummies to help boost digestion & weight loss.";
        break;
      case "Creatine":
        upsellTitle = "Add Another Jar For Only £19.99?";
        upsellContent = "Try our powerfully enriching Creatine supplement for 33% off today.";
        break;

      default:
        upsellTitle = `Add ${upsellName} For Just £19.99?`;
        upsellContent = "Save 50% with this limited time offer and get longer lasting results.";
    }
    if (isBox) {
      upsellTitle = `Try Our ${upsellID == 7512648024240 ? "Salted Caramel Protein" : "Chocolate Protein"} Bars For Just £25.00?`;
      upsellContent = "A box of 12 delicious bars packing 20.3g of protein and just 190 calories.";
    }
    if (isCart) {
      upsellElement = document.querySelector(".cart-items__item--upsell");
      (upsellTitleElement = document.querySelector(".cart-items__item--upsell h4 span:not(.orange)")),
        (upsellContentElement = document.querySelector(".cart-items__item--upsell p")),
        (upsellImageElement = document.querySelector(".cart-items__item--upsell .cart-items__item-image img"));
    }
    upsellPrice = BetterVits.returnUpsellPrice(upsellID);
    if (!isCart) {
      isSub = document.querySelector("[value='sub']").checked;
      if (quantity == 1) {
        upsellID = BetterVits.getDiscountedProductID[productID];
        upsellName = BetterVits.getDiscountedProductsName[upsellID];
        upsellImage = BetterVits.productImage[upsellName];
        upsellPrice = BetterVits.returnUpsellPrice(upsellID);
        upsellTitle = isSub ? `Add 1 More For Just £${upsellPrice}?` : `Add 1 More For Just £${upsellPrice}?`;
        if (upsellID == 7394298626224) {
          keyword = "Jar";
        }
        if (upsellID == 7472617914544) {
          keyword = "Pouch";
        }
        if (upsellID == 7512648024240 || upsellID == 7512648122544) {
          keyword = "Box";
        }
        // "Add Another Jar For Just " +
        // (upsellName == "Multivitamin" ? "£16.99!" : "£19.99!");
        if (upsellName.toLowerCase().indexOf("kids") > -1) {
          upsellContent = isSub
            ? `Give your kids longer lasting results and save by adding an extra ${keyword.toLowerCase()} of our ${upsellName}.`
            : `Upgrade and save by adding 1 more  ${keyword.toLowerCase()}. All bottles come with a 60 day money back guarantee.`;
        } else {
          upsellContent = isSub
            ? `Give yourself longer lasting results and save by adding an extra  ${keyword.toLowerCase()} of our ${upsellName}.`
            : `Upgrade and save by adding 1 more ${keyword.toLowerCase()}. All bottles come with a 60 day money back guarantee.`;
        }
        if (upsellName.toLowerCase().indexOf("protein") > -1) {
          upsellTitle = isSub ? "Add 1 More & Save!" : "Add 1 More For Just £25.00?";
          upsellContent = isSub
            ? `Give yourself longer lasting results and save by adding an extra box of our ${upsellName}.`
            : "Upgrade and save by adding 1 more box. All boxes come with a 60 day money back guarantee.";
        }
      }
    }
    upsellElement.classList.remove(
      "multivitamin",
      "probiotic",
      "vitamin-d3-k2",
      "probiotic-complex",
      "magnesium-complex",
      "glucosamine-complex",
      "niacinamide",
      "vitamin",
      "marine",
      "turmeric",
      "pms",
      "vitamin-c",
      "menopause",
      "ashwagandha",
      "apple",
      "kids",
      "omega",
      "berberine",
      "biotin",
      "primrose",
      "coenzyme-q10",
      "zinc",
      "asleep",
      "creatine",
      "mushroom",
      "powder",
      "protein",
      "bar",
      "vitamin",
      "b",
      "iron",
      "complex",
      "intimate",
      "nmn",
      "pcos"
    );

    upsellElement.classList.add(upsellName.toLowerCase().split(" ")[0]);
    if (upsellName.toLowerCase().split(" ")[1]) {
      upsellElement.classList.add(upsellName.toLowerCase().split(" ")[1]);
    }

    upsellTitleElement.innerHTML = upsellTitle;
    upsellContentElement.innerHTML = upsellContent;

    if (isCart) {
      upsellImageElement.src = upsellImage;
      upsellTitleElement.innerHTML = `Add Another ${keyword} for <u>Just £${upsellPrice}?</u>`;
      upsellContentElement.innerHTML = upsellContent;
    } else {
      upsellImageElement.style.backgroundImage = "url('" + upsellImage + "')";
    }

    upsellElement.dataset.variant = upsellID;

    upsellElement.classList.remove("hidden");
    upsellElement.classList.add("active");

    if (isSoloProduct && !isCart) {
      if (quantity > 3) {
        upsellElement.classList.add("hidden");
        upsellElement.classList.remove("active");
      } else {
        upsellElement.classList.remove("hidden");
        upsellElement.classList.add("active");
        upsellTitleElement.innerHTML = `Save 14% With Autoship!`;
        upsellContentElement.innerHTML = `Choose your delivery frequency and cancel anytime. Save 14% when you switch to autoship now.`;
      }
      if (isSub) {
        upsellElement.classList.add("hidden");
        upsellElement.classList.remove("active");
      }
    }
    if (isBox && quantity > 5 && isSub) {
      upsellElement.classList.add("hidden");
      upsellElement.classList.remove("active");
    }
     document.querySelector('[action*="/cart"] [type="submit"]').addEventListener("click", function (ev) {
      ev.preventDefault();
      this.classList.add("active");
      if (document.querySelector(".upsell__check").classList.contains("active")) {
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4 && xhr.status == 200) {
            if (isCart) {
              window.location.href = "/checkout";
            } else {
              document.querySelector('[action*="/cart"]').submit();
            }
          }
        };
        var offerVariantId = BetterVits.getDiscountedProductVariant[upsellID];
        xhr.open("POST", "/cart/add.js", true);
        xhr.setRequestHeader("Content-Type", "application/json");

        var isSubscription = false;
        if (document.querySelector(".rc_widget__option__input--subsave")) {
          isSubscription = document.querySelector(".rc_widget__option__input--subsave").checked || isSoloProduct;
        }

        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4 && xhr.status == 200) {
            if (isCart) {
              window.location.href = "/checkout";
            } else {
              document.querySelector('[action*="/cart/add"]').submit();
            }
          }
        };

        xhr.send(
          JSON.stringify({
            attributes: {
              /* Promo: isCart ? "" : "",
              Parent: variantID,*/
            },
            items: isSubscription
              ? [
                  {
                    quantity: isSoloProduct ? quantity : 1,
                    selling_plan: isCart
                      ? null
                      : BetterVits.offersSellingPlans[BetterVits.getDiscountedProductVariant[parseInt(document.querySelector(".upsell").dataset.variant)]][
                          parseInt(document.querySelector("#delivery-freq").value) / 30 - 1
                        ],
                    id: BetterVits.getDiscountedProductVariant[parseInt(document.querySelector(".upsell").dataset.variant)],
                    properties: {
                      /*Promo: isCart ? "Cart Special" : "AutoShip Offer",
                      Parent: variantID,*/
                    },
                  },
                ]
              : [
                  {
                    quantity: isSoloProduct ? quantity : 1,
                    id: BetterVits.getDiscountedProductVariant[upsellID],
                    properties: {
                      /* Promo: isCart ? "Cart Special" : "Product Special",
                      Parent: variantID,*/
                    },
                  },
                ],
          })
        );
      } else {
        if (isCart) {
          window.location.href = "/checkout";
        } else {
          document.querySelector('[action*="/cart"]').submit();
        }
      }
    });
  },
  initQtySelector: () => {
    var dropElement = document.querySelector(".product-atf__content-selector");
    var choices = document.querySelectorAll('[name="quantity"]');
    var types = document.querySelectorAll('[name="type"]');
    var quantityLis = document.querySelectorAll(".product-atf__content-selector li"),
      isTesting = !!document.querySelector("#Quantity-atf-reverse-selectors");
    var isSoloProduct = meta.product.variants[0].id == 43178894262448 || meta.product.variants[0].id == 43374296629424;
    var isProteinBar = meta.product.id == 7512646353072 || meta.product.id == 7512648089776;

    for (var j = 0; j < types.length; j++) {
      types[j].addEventListener("click", function () {
        var lis = this.closest("ol").querySelectorAll("li");
        for (var l = 0; l < lis.length; l++) {
          lis[l].classList.remove("active");
        }

        this.closest("li").classList.add("active");
        dropElement.classList.remove("dropped");
        setTimeout(function () {
          var theClass = document.querySelector('[name="type"]:checked').value,
            //theChecked = document.querySelector('[name="choice"]:checked').value,
            theElement = document.querySelector(".is-" + theClass + " input");
          for (var c = 0; c < quantityLis.length; c++) {
            quantityLis[c].style.display = "none";
            if (quantityLis[c].classList.contains("is-" + theClass)) {
              quantityLis[c].style.display = "block";
            }
          }

          dropElement.classList.remove("sub", "otp");
          dropElement.classList.add(theClass);

          if (theClass == "sub") {
            document.querySelector(".product-atf__content-buttons").classList.add("active");
            document.querySelector(".small-ships").classList.add("active");
            document.querySelector(".product-atf__content-monthly").classList.add("active");
          } else {
            document.querySelector(".product-atf__content-buttons").classList.remove("active");
            document.querySelector(".small-ships").classList.remove("active");
            document.querySelector(".product-atf__content-monthly").classList.remove("active");
          }

          theElement.removeAttribute("checked");
          theElement.dataset.checked = false;
          theElement.dispatchEvent(new Event("change"));
          var theSelector = theClass == "sub" ? "[data-label-subsave]" : "[data-label-onetime]";
          //document.querySelector(theSelector).click();
        }, 200);
      });
    }

    for (var j = 0; j < choices.length; j++) {
      choices[j].addEventListener("click", function (ev) {
        document.getElementById("addToCart").removeAttribute("disabled");
        var lis = this.closest("ul").querySelectorAll("li");
        for (var l = 0; l < lis.length; l++) {
          lis[l].classList.remove("come-first");
        }

        this.closest("li").classList.add("come-first");
        dropElement.classList.toggle("dropped");
        document.querySelector(".small-ships").classList.add("eligible");
        if (dropElement.classList.contains("sub")) {
          document.querySelector(".small-ships").classList.add("active");
        }
        //dropElement.classList.add(this.value)
        if (!isTesting) {
          //document.querySelector("#Quantity-product-atf").value = this.value;
        } else {
          //document.querySelector("#Quantity-atf-reverse-selectors").value = this.value;
        }

        BetterVits.cartUpsellInit(this.value, meta.product, false);
      });
    }
    document.querySelector('[name="upsell"]').addEventListener("change", function () {
      var checked = this.checked;
      if (isSoloProduct && dropElement.classList.contains("sub")) {
        if (checked) {
          document.getElementById("delivery-freq").value = parseInt(document.querySelector(".come-first input").value) * 60;

          document.querySelector(".small-ships").classList.add("active");
          document.querySelector(".product-atf__content-monthly").classList.add("active");
        } else {
          document.querySelector(".small-ships").classList.remove("active");
          document.querySelector(".product-atf__content-monthly").classList.remove("active");
        }
      }
    });
    document.getElementById("addToCart").addEventListener("click", function (ev) {
      ev.preventDefault();
      var xhr = new XMLHttpRequest(),
        upsellTaken = document.querySelector("input[name='upsell']").checked,
        quantity = Number(document.querySelector("[name='quantity']:checked").value),
        isSubscription = document.querySelector("[value='sub']").checked || (isSoloProduct && quantity <= 3 && upsellTaken),
        upsellVariant = BetterVits.getDiscountedProductVariant[parseInt(document.querySelector(".upsell").dataset.variant)];
      var items = isSubscription
        ? [
            {
              quantity: upsellTaken ? (isSoloProduct ? 1 : 1) : 0,
              id: upsellVariant,
              selling_plan: BetterVits.offersSellingPlans[upsellVariant][parseInt(document.querySelector("#delivery-freq").value) / 30 - 1],
              properties: {
               "Bought With": meta.product.variants[0].name
              },
            },
            {
              quantity: quantity,
              id: meta.product.variants[0].id,
              selling_plan:
                BetterVits.productsSelingPlans[meta.product.variants[0].id][
                  parseInt(document.querySelector("#delivery-freq").value) / 30 - (document.querySelector("#delivery-freq").value / 30 == 6 ? 2 : 1)
                ],
              properties: {
               /* Promo: "AutoShip Offer",*/
              },
            },
          ]
        : [
            {
              quantity: upsellTaken ? (quantity == 1 ? 1 : 1) : 0,
              id: upsellVariant,
              properties: {
              "Bought With": meta.product.variants[0].name
              },
            },
            {
              quantity: quantity == 1 ? (upsellTaken ? 3 : quantity) : quantity,
              id: meta.product.variants[0].id,
              properties: {
               /* Promo: "Product Upsell",*/
              },
            },
          ];
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4 && xhr.status == 200) {
          //window.location.href = "/cart";
          document.getElementById("CartCount").click();
        }
      };

      xhr.open("POST", "/cart/add.js", true);
      xhr.setRequestHeader("Content-Type", "application/json");
      xhr.send(
        JSON.stringify({
          attributes: {
           /*Special: "Product Special",*/
          },
          items: items,
        })
      );

      //document.querySelector("button.btn.product-form__cart-submit").click();
    });
    if (document.getElementsByClassName("ingridents-show-more-toggle").length > 0) {
      document.getElementsByClassName("ingridents-show-more-toggle")[0].addEventListener("click", function () {
        document.getElementsByClassName("ingredients__list")[0].classList.add("dropped");
        this.remove();
      });
    }
    var subQtys = document.querySelectorAll('.is-sub [name="quantity"]');
    subQtys.forEach((qty) => {
      qty.addEventListener("click", function () {
        var value = Number(this.value);
        var factor = 30;
        if (meta.product.variants[0].id == 42887457145008) {
          factor = 60;
        }
        if (isProteinBar) {
          if (value == 3) {
            value = 2;
          }
          if (value == 6) {
            value = 3;
          }
        }
        document.getElementById("delivery-freq").value = value * factor;
      });
    });
  },
  scrollToReviews: () => {
    if (document.getElementById("backToTop")) {
      document.getElementById("backToTop").addEventListener("click", function (ev) {
        ev.preventDefault();
        BetterVits.isSafari && BetterVits.iOS
          ? document.getElementById("shopify-section-product-atf").scrollIntoView(true)
          : document.getElementById("shopify-section-product-atf").scrollIntoView({
              behavior: "smooth",
            });
      });
    }
    if (document.getElementById("scrollToTestimonials")) {
      document.querySelectorAll(".product-atf__content a.button.secondary.small").forEach((button) => {
        button.addEventListener("click", function (ev) {
          ev.preventDefault();
          BetterVits.isSafari && BetterVits.iOS
            ? document.getElementById("testimonials").scrollIntoView(true)
            : document.getElementById("testimonials").scrollIntoView({
                behavior: "smooth",
              });
        });
      });

      document.getElementById("scrollToTestimonials").addEventListener("click", function (ev) {
        ev.preventDefault();
        BetterVits.isSafari && BetterVits.iOS
          ? document.getElementById("testimonials").scrollIntoView(true)
          : document.getElementById("testimonials").scrollIntoView({
              behavior: "smooth",
            });
      });
    }
    if (document.getElementById("shopify-section-product-atf")) {
      var scrollTotops = document.querySelectorAll("#shopify-section-product-atf ~ section .button.primary");
      for (var j = 0; j < scrollTotops.length; j++) {
        scrollTotops[j].addEventListener("click", function (ev) {
          ev.preventDefault();
          BetterVits.isSafari && BetterVits.iOS
            ? document.getElementById("shopify-section-product-atf").scrollIntoView(true)
            : document.getElementById("shopify-section-product-atf").scrollIntoView({
                behavior: "smooth",
              });
        });
      }
    }
  },
  scrollEvents: () => {
    console.log("scrolling");
    if (document.body.classList.contains("protein-bar-chocolate-brownie") || document.body.classList.contains("protein-bar")) {
      if (BetterVits.isElementInView(document.querySelector(".perfection"))) {
        document.querySelector(".perfection").classList.add("active");
      }
    }
    if (!!document.querySelector(".redefining-green")) {
      if (BetterVits.isElementInView(document.querySelector(".redefining-green"))) {
        document.querySelector(".redefining-green").classList.add("active");
      }
    }
    if (!!document.querySelector(".animated-arrow")) {
      var svgs = document.querySelectorAll(".animated-arrow");

      svgs.forEach(function (svg) {
        if (BetterVits.isElementInView(svg) && !svg.classList.contains("active")) {
          svg.classList.add("active");

          var pathAnim = svg.querySelector(".path-anim");
          var triangleAnim = svg.querySelector(".triangle-anim");
          var started = false;

          function checkActive() {
            if (!started && svg.classList.contains("active")) {
              pathAnim.beginElement();
              triangleAnim.beginElement();
              started = true;
            }
          }

          // Check immediately in case class is already added
          checkActive();

          // Use MutationObserver to watch for class changes
          var observer = new MutationObserver(checkActive);
          observer.observe(svg, { attributes: true, attributeFilter: ["class"] });
          svg.classList.add("activated");
        }
      });
    }
  },
  setTimeout: (el, delay, className) => {
    setTimeout(function () {
      el.classList.add(className);
    }, delay);
  },
  initReviews: () => {
    document.getElementById("submit").addEventListener("click", function (ev) {
      if (!document.getElementById("newReview").checkValidity()) return false;
      document.querySelector(".confirmation img").src = document.querySelector(".confirmation img").src;
      document.querySelector(".confirmation").classList.add("show");
      setTimeout(function () {
        document.querySelector(".reviews-modal").classList.remove("visible");
        document.querySelector(".confirmation").classList.remove("show");
      }, 2000);
    });
    var rateStars = document.getElementsByName("rating"),
      allReviews = document.querySelectorAll("[data-rating]"),
      readmores = document.querySelectorAll(".read-more");

    for (var s = 0; s < rateStars.length; s++) {
      if (!rateStars[s]) return false;
      rateStars[s].addEventListener("click", function (ev) {
        var rating = this.value;
        var filtered = document.querySelectorAll("[data-rating='" + rating + "']");
        for (var a = 0; a < allReviews.length; a++) {
          var item = allReviews[a];
          item.classList.add("hide-animate");
        }
        setTimeout(function () {
          for (var a = 0; a < allReviews.length; a++) {
            var item = allReviews[a];
            item.classList.remove("show");
            item.classList.remove("show-animate");
            item.classList.add("hide");
          }
          for (var f = 0; f < filtered.length; f++) {
            var item = filtered[f];
            item.classList.add("show");
            item.classList.remove("hide");
            item.classList.remove("hide-animate");
          }

          setTimeout(function () {
            for (var f = 0; f < filtered.length; f++) {
              var item = filtered[f];
              item.classList.add("show-animate");
            }
          }, 300);
        }, 300);

        if (filtered.length == 0) {
          document.querySelector(".reviews-list__footer").classList.add("hide");
        } else {
          document.querySelector(".reviews-list__footer").classList.remove("hide");
        }
      });
    }

    for (var r = 0; r < readmores.length; r++) {
      if (!readmores[r]) return false;
      readmores[r].addEventListener("click", function (ev) {
        ev.preventDefault();
        this.closest("p").classList.add("active");
        this.remove();
      });
    }
    var currentPage = 1;
    document.getElementById("appendMoreReviews").addEventListener("click", (ev) => {
      ev.preventDefault();
      currentPage = currentPage + 1;
      if (currentPage == 4) {
        document.getElementById("appendMoreReviews").remove();
      }
      document.getElementById("reviewsList").dataset.page = currentPage;
    });
    document.getElementById("leaveReview").addEventListener("click", (ev) => {
      ev.preventDefault();
      document.querySelector(".reviews-modal").classList.add("visible");
    });
    document.getElementById("closeModal").addEventListener("click", (ev) => {
      ev.preventDefault();
      document.querySelector(".reviews-modal").classList.remove("visible");
    });
  },
  initCart: () => {
    if (document.documentElement.classList.contains("emptyness")) {
      return false;
    }
    var pricing = document.querySelector(".final-price");
    var value = Number(pricing.innerText.replace(/[^0-9\.-]+/g, ""));
    var increments = document.getElementsByClassName("increment"),
      decrements = document.getElementsByClassName("decrement"),
      rows = document.querySelectorAll('[action="/cart"] li.cart-items__item:not(.cart-items__item--upsell)'),
      rogueRows = document.querySelectorAll("li.cart-items__item.offer"),
      regularRows = document.querySelectorAll("li.cart-items__item:not(.offer):not(.cart-items__item--upsell)");

    if (value <= 45) {
      // document.querySelector(".cart-header").classList.add("show");
    }

    if (rogueRows.length > 0 && regularRows.length == 0) {
      document.querySelector(".cart-items__item.cart-items__item--upsell").remove();
      document.querySelector('[action*="/cart"]').remove();

      var updateString = "updates[" + rogueRows[0].dataset.cartItemKey.split(":")[0] + "]=0";
      for (var i = 0; i < rogueRows.length; i++) {
        updateString = updateString + "&updates[" + rogueRows[i].dataset.cartItemKey.split(":")[0] + "]=0";
        rogueRows[i].remove();
      }

      var xhr = new XMLHttpRequest();
      xhr.onreadystatechange = function () {
        if (xhr.readyState == 4 && xhr.status == 200) {
          location.reload();
        }
      };
      xhr.open("POST", "/cart/update.js", true);
      xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");

      xhr.send(updateString);

      return false;
    }
    if (!document.querySelector(".upsell__check")) return false;
    document.querySelector(".upsell__check").addEventListener("click", function (uc) {
      var isMulti = document.querySelector(".cart-items__item.cart-items__item--upsell.active").classList.contains("multivitamin");
      var isBox = document.querySelector(".cart-items__item.cart-items__item--upsell.active").classList.contains("protein");
      var isNMN = document.querySelector(".cart-items__item.cart-items__item--upsell.active").classList.contains("nmn");
      var isGreens = document.querySelector(".cart-items__item.cart-items__item--upsell.active").classList.contains("bettergreens");
      var upsellPrice = 19.99;
      if (isMulti) {
        upsellPrice = 16.99;
      }
      if (isBox || isNMN) {
        upsellPrice = 25.0;
      }
      if (isGreens) {
        upsellPrice = 29.99;
      }

      this.classList.toggle("active");
      pricing.innerText = "£" + (this.classList.contains("active") ? value + upsellPrice : value).toFixed(2) + " GBP";
    });

    for (var i = 0; i < increments.length; i++) {
      increments[i].addEventListener("click", function () {
        var parentTR = this.closest("li");
        if (parentTR.classList.contains("is-subscription") && Number(this.closest("div").querySelector(".cart__qty-input").value) >= 3) {
          parentTR.classList.add("limited");
        } else {
          this.closest("div").querySelector(".cart__qty-input").stepUp();
        }
      });
    }

    for (var d = 0; d < decrements.length; d++) {
      decrements[d].addEventListener("click", function () {
        this.closest("li").classList.remove("limited");
        this.closest("div").querySelector(".cart__qty-input").stepDown();
      });
    }
    for (var r = 0; r < rows.length; r++) {
      rows[r].querySelector(".remove-line").addEventListener("click", function (ev) {
        ev.preventDefault;
        ev.stopPropagation();
        var rowVariant = this.dataset.variant;
        var hasPretenders = document.querySelectorAll("[data-cart-item-props='" + rowVariant + "0']");
        var xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4 && xhr.status == 200) {
            setTimeout(function () {
              location.reload();
            }, 300);
          }
        };
        xhr.open("POST", "/cart/update.js", true);
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        var updateString = "updates[" + rowVariant + "]=0";
        if (hasPretenders.length > 0) {
          for (var p = 0; p < hasPretenders.length; p++) {
            updateString = updateString + "&updates[" + hasPretenders[p].dataset.cartItemVariant + "]=0";
          }
        }
        xhr.send(updateString);
      });
    }
    if (document.querySelectorAll('[data-cart-item-variant="40607286755504"]').length == 1 && document.querySelectorAll("[data-cart-item-variant]").length == 1) {
      BetterVits.cartUpsellInit(1, { id: 6873010405552, variants: [{ id: 40617577676976 }] }, true);
    } else {
      // if (document.querySelectorAll('[data-cart-item-variant="40617577676976"]').length == 0) {
      //    BetterVits.cartUpsellInit(1, { id: 6873015255216, variants: [{ id: 40617579118768 }] }, true);
      //  } else {
      var xmlhttp = new XMLHttpRequest(),
        smallest = 100,
        upsellItem = {};
      xmlhttp.onreadystatechange = function () {
        if (xmlhttp.readyState == XMLHttpRequest.DONE) {
          if (xmlhttp.status == 200) {
            var itemsArray = JSON.parse(xmlhttp.responseText).items;

            for (var productItem in itemsArray) {
              var quantity = itemsArray[productItem].quantity;
              if (quantity < smallest && !Object.values(BetterVits.getDiscountedProductVariant).includes(itemsArray[productItem].id)) {
                smallest = quantity;
                upsellItem = itemsArray[productItem];
              }
            }
            BetterVits.cartUpsellInit(
              1,
              {
                id: upsellItem.product_id,
                variants: [{ id: upsellItem.id }],
              },
              true
            );
          } else if (xmlhttp.status == 400) {
            alert("There was an error 400");
          } else {
            alert("something else other than 200 was returned");
          }
        }
      };

      xmlhttp.open("GET", "/cart.js", true);
      xmlhttp.send();
      //}
    }
  },
  setCookie: function (cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
    let expires = "expires=" + d.toUTCString();
    document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
  },
  getCookie: function (cname) {
    let name = cname + "=";
    let ca = document.cookie.split(";");
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == " ") {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  },
  initNotification: function () {
    var notificationEl = document.getElementById("bettervits-notification");
    if (notificationEl.innerText.trim().length > 10) {
      let notification = BetterVits.getCookie("notification");
      if (notification !== "true") {
        notificationEl.classList.remove("inactive");
        document.getElementById("PageContainer").classList.add("has-notification");
      }
      document.getElementById("close-notification").addEventListener("click", function () {
        BetterVits.setCookie("notification", "true", 10);
        notificationEl.classList.add("inactive");
        document.getElementById("PageContainer").classList.remove("has-notification");
      });
    }
  },
  reChargeChecker: function () {
    var rechargeAppeared = false;
    var recharges = document.querySelectorAll("li.is-sub");
    for (var j = 0; j < recharges.length; j++) {
      recharges[j].setAttribute("disabled", "disabled");
    }

    for (var j = 0; j < recharges.length; j++) {
      recharges[j].removeAttribute("disabled");
    }
    document.querySelector(".product-atf__content").classList.add("present");
    document.querySelector(".product-atf__content [name='type']").dispatchEvent(new Event("change"));
  },
  upsellToggles: function () {
    var upsellToggles = document.querySelectorAll(".upsellToSub__input");
    for (var j = 0; j < upsellToggles.length; j++) {
      upsellToggles[j].addEventListener("change", function () {
        var controls = this.closest("li").querySelectorAll("label.upsellToSub");

        [].forEach.call(controls, (el) => {
          el.classList.add("active");
        });

        var theVariant = this.value.split(":")[0],
          qty = this.dataset.qty;
        var xhr = new XMLHttpRequest();
        var isOffer = this.closest("li").classList.contains("offer");
        var index = parseInt(this.closest("label").querySelector(".delfreq").value) / 30 - 1;
        var sP = isOffer ? BetterVits.offersSellingPlans[theVariant][index] : BetterVits.productsSelingPlans[theVariant][index];
        xhr.onreadystatechange = function () {
          if (xhr.readyState == 4 && xhr.status == 200) {
            var xhrSUB = new XMLHttpRequest();
            xhrSUB.onreadystatechange = function () {
              if (xhrSUB.readyState == 4 && xhrSUB.status == 200) {
                window.location.href = "/cart";
              }
            };
            xhrSUB.open("POST", "/cart/add.js", true);
            xhrSUB.setRequestHeader("Content-Type", "application/json");
            xhrSUB.send(
              JSON.stringify({
                items: [
                  {
                    quantity: qty,
                    id: theVariant,
                    selling_plan: sP,
                  },
                ],
              })
            );
          }
        };
        xhr.open("POST", "/cart/change.js", true);
        xhr.setRequestHeader("Content-type", "application/x-www-form-urlencoded");
        xhr.send("line=" + this.closest("li").dataset.cartItemIndex + "&quantity=0");
      });
    }
  },
  insertAfter: function (newNode, existingNode) {
    existingNode.parentNode.insertBefore(newNode, existingNode.nextSibling);
  },
  insertBefore: function (newNode, existingNode) {
    existingNode.parentNode.insertBefore(newNode, existingNode);
  },
  createElementFromHTML: function (htmlString) {
    var div = document.createElement("div");
    div.innerHTML = htmlString.trim();

    // Change this to div.childNodes to support multiple top-level nodes
    return div.firstChild;
  },
  rewordReCharge: function () {
    var root = document.querySelector("section.rc-login");
    var customer =
      BetterVits.getCookie("BV_subscription_customer").length > 5
        ? JSON.parse(BetterVits.getCookie("BV_subscription_customer"))
        : JSON.parse(JSON.stringify({ isSub: false, email: "" }));
    var isSub = customer.isSub,
      customerEmail = customer.email;
    document.body.classList.add("recharge-login");
    var sectionTitle = document.querySelector("section.rc-login").querySelector("h1.rc-login--header-title");
    var sectionBody = document.querySelector("section.rc-login").querySelector("label.rc-login-form-label");
    if (sectionBody) {
      if (isSub && !!document.getElementById("rc-email")) {
        document.getElementById("rc-email").value = customerEmail;
        //document.getElementById("login_verification").submit();
        sectionTitle.innerText = "Access Subscription";
        document.querySelector("button.rc-login-form-button.animated span").innerText = "Send Login Link (Email & SMS)";

        sectionBody.innerText = "We have detected a subscription account with this e-mail. Click 'Submit' to get access to your account.";
      } else {
        document.querySelector("button.rc-login-form-button.animated span").innerText = "Send Login Link (Email & SMS)";
        sectionTitle.innerText = "Access Subscription";
        sectionBody.innerHTML = "Please enter <b>the email you used for your order</b> to access your subscription.";
        BetterVits.insertAfter(
          BetterVits.createElementFromHTML(`<div style="font-size: 12px;padding: 0 2rem;text-align: center;color: #123840;"><br><h4 style="
            font-size: 18px;
            margin: 0rem 0 16px 0;
        ">Need Help?</h4>You may access your subscription using this page to modify your delivery frequency or cancel your subscription. In order to gain access, please ensure you are using the same email you placed your initial order with.
            <br>

               <br>
            <b>If you need help managing your subscription, please <a hreflang="en-GB" href="/pages/contact">Contact Us Here</a>. We're happy to help you manage your subscription as needed.</b></div>`),
          document.querySelector(".rc-login--body")
        );
        root.style.opacity = 1;
      }
    } else {
      if (isSub) {
        sectionBody.innerHTML = `
          We have sent you an e-mail to: <b>${customerEmail}</b><br>
          Please check your inbox (including spam) for a link to access your subscription.
          `;
      }
      root.style.opacity = 1;
    }
  },
  updateProductImage: function () {
    var target = document.querySelector(".comparison__bv img"),
      coverImage = document.querySelector(".comparison-img");
    if (!!target) {
      target.dataset.src = coverImage.dataset.src;
      target.src = coverImage.dataset.src;
    }
  },
  initFloaterATC: function () {
    var el = document.querySelector(".floater-atc"),
      atcElement = document.getElementById("addToCart");
    if (!el) {
      return false;
    }
    var atcPosition = window.scrollY + atcElement.getBoundingClientRect().top;
    el.addEventListener("click", function () {
      if (atcElement.getAttribute("disabled") == null) {
        atcElement.click();
      } else {
        //document.querySelector(".green-section__cell .button.primary").click();
      }
    });
    window.addEventListener("scroll", function () {
      if (window.scrollY > atcPosition) {
        el.classList.add("active");
      } else {
        el.classList.remove("active");
      }
      if (document.querySelector(".benefits-of-product-new")) {
        if (BetterVits.isElementInView(document.querySelector(".benefits-of-product-new h2"))) {
          document.querySelectorAll(".benefits-of-product-new__list li").forEach((listitem) => {
            listitem.classList.add("active");
          });
        }
      }
    });
  },
  handleTabs: function () {
    var tabs = document.querySelectorAll(".faq-nutri__tabs a"),
      contents = document.querySelectorAll(".faq-nutri__content--panel");
    tabs.forEach((clicker) => {
      clicker.addEventListener("click", function () {
        tabs.forEach((link) => {
          link.classList.remove("active");
        });
        contents.forEach((link) => {
          link.classList.remove("active");
        });
        clicker.classList.add("active");
        document.querySelector(`.faq-nutri__content--panel[data-id='${clicker.dataset.id}']`).classList.add("active");
      });
    });
  },
  initGeoIPdetection: function () {
    let cookiePresent = BetterVits.getCookie("geoIPRedirect");
    if (cookiePresent == "leave") {
      window.location.href = "https://bettervits.com";
    }
    if (cookiePresent.length > 0) {
      return false;
    }

    var detectCountry = function (geoipResponse) {
      var countryCode = geoipResponse.country.iso_code || "UK";
      if (countryCode == "US") {
        document.getElementById("geoip-banner").classList.add("active");
        document.querySelectorAll(".choices").forEach((choice) => {
          choice.addEventListener("click", function (ev) {
            ev.preventDefault();
            var selection = choice.id;
            BetterVits.setCookie("geoIPRedirect", selection, 1);
            document.getElementById("geoip-banner").classList.remove("active");
            if (selection == "leave") {
              window.location.href = choice.href;
            }
          });
        });
      }
      console.log("GeoIP response:");
      console.log(geoipResponse);
    };

    var onSuccess = function (geoipResponse) {
      detectCountry(geoipResponse);
    };

    // If we get an error, we will display an error message
    var onError = function (error) {
      document.getElementById("geoip-banner").innerHTML = "an error!  Please try again..";
    };

    if (typeof geoip2 !== "undefined") {
      geoip2.country(onSuccess, onError);
    } else {
      document.querySelector("#geoip-banner p").innerHTML = "You're using a browser that blocks GeoIP2 requests";
    }
  },
  initCookieBanner: function () {
    let cookiePresent = BetterVits.getCookie("BVcookieAccept"),
      banner = document.getElementById("cookieBanner");

    if (cookiePresent.length == 0) {
      setTimeout(function () {
        banner.classList.add("active");
      }, 5000);
    }

    document.querySelectorAll(".cookie-banner__wrapper .buttons a").forEach((button) => {
      button.addEventListener("click", function (ev) {
        ev.preventDefault();
        banner.classList.remove("active");
        BetterVits.setCookie("BVcookieAccept", button.className, 365);
      });
    });
  },
  globalEvents: function () {
       if (document.querySelectorAll(".start-journey").length > 0) {
      document.querySelectorAll(".start-journey").forEach((element) => {
        element.addEventListener("click", function (ev) {
          if (document.body.classList.contains("product")) {
          ev.preventDefault();
          BetterVits.isSafari && BetterVits.iOS
            ? document.querySelector(".product-atf").scrollIntoView(true)
            : document.querySelector(".product-atf").scrollIntoView({
                behavior: "smooth",
              });
            }
        });
      });
    }
  },
  homepageBestSellers: function () {
    document.addEventListener("DOMContentLoaded", function () {
      // Initialize the Splide slider

      let bestSellersSlider = new Splide("#best-sellers-slider", {
        type: "loop",
        perPage: 3,
        gap: "1rem",
        speed: 333,
        easing: "cubic-bezier(0.55, 0.24, 0.52, 1.0)",
        autoplay: false,
        interval: 6000,
        padding: { right: "10%" },
        pagination: false,
        arrows: true,
        arrowPath:
          "M1.60547 4.8813C1.21887 4.8813 0.905469 5.1947 0.905469 5.5813C0.905469 5.9679 1.21887 6.2813 1.60547 6.2813L1.60547 4.8813ZM25.3717 6.07627C25.6451 5.80291 25.6451 5.35969 25.3717 5.08633L20.9169 0.631552C20.6435 0.358185 20.2003 0.358185 19.927 0.631552C19.6536 0.904919 19.6536 1.34813 19.927 1.6215L23.8868 5.5813L19.927 9.5411C19.6536 9.81446 19.6536 10.2577 19.927 10.531C20.2003 10.8044 20.6435 10.8044 20.9169 10.531L25.3717 6.07627ZM1.60547 5.5813L1.60547 6.2813L13.2411 6.2813L13.2411 5.5813L13.2411 4.8813L1.60547 4.8813L1.60547 5.5813ZM13.2411 5.5813L13.2411 6.2813L24.8767 6.2813L24.8767 5.5813L24.8767 4.8813L13.2411 4.8813L13.2411 5.5813Z",
        breakpoints: {
          767: {
            perPage: 1,
            padding: { right: "20%" },
          },
          1024: {
            perPage: 2,
            padding: { right: "15%" },
          },
        },
      });

      // Mount the slider
      bestSellersSlider.mount();

      // Get all filter links and slides
      const filterLinks = document.querySelectorAll(".best-sellers__left ul li a");
      const allSlides = document.querySelectorAll(".splide__slide[data-filter]");

      // Function to filter products
      function filterProducts(filterValue) {
        // Remove all slides from the slider
        bestSellersSlider.destroy();

        // Get the splide list container
        const splideList = document.querySelector("#best-sellers-slider .splide__list");

        // Filter slides based on the selected filter
        let visibleSlides = [];

        if (filterValue === "best-sellers") {
          // Show all slides for best-sellers
          visibleSlides = Array.from(allSlides);
        } else {
          // Filter slides based on data-filter attribute
          visibleSlides = Array.from(allSlides).filter((slide) => {
            const slideFilters = slide.getAttribute("data-filter").split(" ");
            return slideFilters.includes(filterValue);
          });
        }

        // Clear the splide list
        splideList.innerHTML = "";

       function shuffleArray(arr) {
          for (let i = arr.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [arr[i], arr[j]] = [arr[j], arr[i]]; // swap
          }
        }

        shuffleArray(visibleSlides);

        visibleSlides.forEach((slide) => {
          splideList.appendChild(slide.cloneNode(true));
        });

        // Reinitialize the Splide slider with the same configuration
        bestSellersSlider = new Splide("#best-sellers-slider", {
          type: "loop",
          perPage: 3,
          gap: "1rem",
          speed: 333,
          easing: "cubic-bezier(0.55, 0.24, 0.52, 1.0)",
          autoplay: false,
          interval: 6000,
          padding: { right: "10%" },
          pagination: false,
          arrows: true,
          arrowPath:
            "M1.60547 4.8813C1.21887 4.8813 0.905469 5.1947 0.905469 5.5813C0.905469 5.9679 1.21887 6.2813 1.60547 6.2813L1.60547 4.8813ZM25.3717 6.07627C25.6451 5.80291 25.6451 5.35969 25.3717 5.08633L20.9169 0.631552C20.6435 0.358185 20.2003 0.358185 19.927 0.631552C19.6536 0.904919 19.6536 1.34813 19.927 1.6215L23.8868 5.5813L19.927 9.5411C19.6536 9.81446 19.6536 10.2577 19.927 10.531C20.2003 10.8044 20.6435 10.8044 20.9169 10.531L25.3717 6.07627ZM1.60547 5.5813L1.60547 6.2813L13.2411 6.2813L13.2411 5.5813L13.2411 4.8813L1.60547 4.8813L1.60547 5.5813ZM13.2411 5.5813L13.2411 6.2813L24.8767 6.2813L24.8767 5.5813L24.8767 4.8813L13.2411 4.8813L13.2411 5.5813Z",
          breakpoints: {
            767: {
              perPage: 1,
              padding: { right: "20%" },
            },
            1024: {
              perPage: 2,
              padding: { right: "15%" },
            },
          },
        });

        // Mount the reinitialized slider
        bestSellersSlider.mount();
      }

      // Add click event listeners to filter links
      filterLinks.forEach((link) => {
        link.addEventListener("click", function (e) {
          e.preventDefault();

          // Remove active class from all links
          filterLinks.forEach((l) => l.classList.remove("active"));

          // Add active class to clicked link
          this.classList.add("active");

          // Get the filter value from data-id attribute
          const filterValue = this.getAttribute("data-id");

          // Filter the products
          filterProducts(filterValue);
        });
      });
    });
  },
    injectCTAs: function(){
      BetterVits.insertAfter(BetterVits.createElementFromHTML(`<a href="/pages/shop" class="button dark start-journey">Buy Now</a>`), document.querySelector(".vouched-for__left h4"))
      BetterVits.insertAfter(BetterVits.createElementFromHTML(`<a href="/pages/shop" class="button dark start-journey">Buy Now</a>`), document.querySelector(".meet-your-ingredients__left ul"))
  }
};

if (document.body.classList.contains("template-")) {
  BetterVits.rewordReCharge();
}

if (document.body.classList.contains("product")) {
  BetterVits.scrollToReviews();
  BetterVits.initQtySelector();
  BetterVits.reChargeChecker();
  BetterVits.updateProductImage();
  BetterVits.handleTabs();
  BetterVits.initFloaterATC();
  BetterVits.injectCTAs();
}

if (document.body.classList.contains("cart")) {
  BetterVits.initCart();
  BetterVits.upsellToggles();
}
if (document.body.classList.contains("reviews")) {
  // BetterVits.initReviews();
}

if (document.body.classList.contains("index") || document.body.classList.contains("cart")) {
  BetterVits.homepageBestSellers();
}

BetterVits.initCarsousels();
BetterVits.customSticky();
BetterVits.initMobileMenu();
BetterVits.initFAQ();
BetterVits.globalEvents();

//BetterVits.initNotification();
/*
setTimeout(function () {
  BetterVits.initGeoIPdetection();
  BetterVits.initCookieBanner();
}, 8000);*/

for (const video of document.querySelectorAll("video")) {
  if (window.innerWidth >= 768) {
    video.controls = false;
    video.addEventListener("mouseover", () => {
      video.controls = "controls";
      video.play();
    });
    video.addEventListener("mouseout", () => {
      video.controls = false;
      video.pause();
    });
  } else {
    video.controls = true;
  }
}

document.addEventListener("DOMContentLoaded", function () {
  window.addEventListener("scroll", function () {
    BetterVits.customSticky();
    BetterVits.scrollEvents();
  });
});
